import React, { Component } from "react";
import Slider from "./Slider";
import localForage from "localforage";
import Checkout from "./CheckoutForm";
import { Elements } from "react-stripe-elements";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";

@inject("ProductStore", "CartStore", "UserStore")
@observer
class SingleProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDays: 1,
      tab: "description",
      waiver: false,
      quantity: 1,
      checkoutOpen: false,
      downloadMode: false
    };
  }

  componentDidMount = () => {
    this.props.UserStore.getMyDownloads();
    this.props.ProductStore.getProduct(this.props.match.params.id);
    localForage.getItem("cart").then(items => {
      this.props.CartStore.setCart(items);
    });
  };

  componentWillUnmount = () => {
    this.props.ProductStore.resetSelectedProduct();
  };

  isBought = () => {
    console.log(
      this.props.UserStore.downloads.map(download => download._product._id),
      this.props.ProductStore.selectedProduct._id
    );
    return (
      this.props.UserStore.downloads
        .map(download => download._product._id)
        .indexOf(this.props.ProductStore.selectedProduct._id) > -1
    );
  };

  inCart() {
    const filteredCart = this.props.CartStore.items
      ? this.props.CartStore.items.filter(
          item => item._id === this.props.ProductStore.selectedProduct._id
        )[0]
      : null;
    return filteredCart ? true : false;
  }

  toggleDownloadProduct = () => {
    this.setState({
      downloadMode: true,
      checkoutOpen: !this.state.checkoutOpen
    });
  };

  render() {
    const { selectedProduct } = this.props.ProductStore;
    return (
      <div className="main-content single-content">
        <div
          className={
            "formModalOverlay " + (this.state.checkoutOpen ? "visible" : "")
          }
          onClick={this.toggleDownloadProduct}
        />
        <Elements>
          <Checkout
            isOpen={this.state.checkoutOpen}
            downloadMode={this.state.downloadMode}
            price={selectedProduct.price}
            targetProduct={selectedProduct}
            toggleModal={this.toggleDownloadProduct}
          />
        </Elements>
        <div className="section-title standalone">
          <p>VIEW PRODUCT</p>
          <div className="sep" />
        </div>
        <div className="info-holder">
          <div className="product-full-desc">
            <div className="pic-specs">
              <Slider
                images={selectedProduct.images ? selectedProduct.images : []}
              />
              <div className="full-spec">
                <p>
                  <b>{selectedProduct.name}</b>
                </p>
                <ul>
                  {selectedProduct.specs
                    ? selectedProduct.specs.map(spec => (
                        <li key={spec}>{spec}</li>
                      ))
                    : null}
                </ul>
              </div>
            </div>
            <div className="more-info">
              {selectedProduct.description ? (
                <div className="head-tabs">
                  {selectedProduct.description ? (
                    <p
                      className={
                        this.state.tab === "description" ? "active" : null
                      }
                      onClick={() => this.setState({ tab: "description" })}
                    >
                      Description
                    </p>
                  ) : null}
                  {selectedProduct.notes.length > 0 ? (
                    <p
                      className={this.state.tab === "notes" ? "active" : null}
                      onClick={() => this.setState({ tab: "notes" })}
                    >
                      Notes
                    </p>
                  ) : null}
                  {selectedProduct.includes.length > 0 ? (
                    <p
                      className={
                        this.state.tab === "includes" ? "active" : null
                      }
                      onClick={() => this.setState({ tab: "includes" })}
                    >
                      Includes
                    </p>
                  ) : null}
                  {selectedProduct.specs.length > 0 ? (
                    <p
                      className={this.state.tab === "specs" ? "active" : null}
                      onClick={() => this.setState({ tab: "specs" })}
                    >
                      Specs
                    </p>
                  ) : null}
                </div>
              ) : null}
              <div className="content-text">
                {selectedProduct.notes ? (
                  this.state.tab === "description" ? (
                    <p>{selectedProduct.description}</p>
                  ) : this.state.tab === "notes" ? (
                    selectedProduct.notes.map(note => (
                      <li key={note}>{note}</li>
                    ))
                  ) : this.state.tab === "includes" ? (
                    selectedProduct.includes.map(include => (
                      <li key={include}>{include}</li>
                    ))
                  ) : this.state.tab === "specs" ? (
                    selectedProduct.specs.map(spec => (
                      <li key={spec}>{spec}</li>
                    ))
                  ) : null
                ) : null}
              </div>
            </div>
          </div>
          <div className="buy-side-bar">
            <div
              className={
                "cart-box " + (selectedProduct ? selectedProduct.available : "")
              }
            >
              <div className="cb-head">
                <p>
                  Total Price: $
                  {selectedProduct.available === "rent"
                    ? (
                        ((parseInt(this.state.selectedDays, 10) === 1
                          ? selectedProduct.pricePerDay
                          : parseInt(this.state.selectedDays, 10) === 2
                          ? selectedProduct.pricePerDay * 1.7
                          : parseInt(this.state.selectedDays, 10) === 3
                          ? selectedProduct.pricePerDay * 1.95
                          : parseInt(this.state.selectedDays, 10) >= 4 &&
                            parseInt(this.state.selectedDays, 10) <= 7
                          ? selectedProduct.pricePerDay * 2.95
                          : selectedProduct.pricePerDay * 2.95 +
                            (parseInt(this.state.selectedDays, 10) - 7) *
                              selectedProduct.pricePerDay *
                              0.42) +
                          (this.state.waiver
                            ? selectedProduct.price * 0.05
                            : 0)) *
                        this.state.quantity
                      ).toFixed(2)
                    : selectedProduct.price}
                </p>
                {selectedProduct.available === "rent" ? (
                  <p>
                    ${selectedProduct.pricePerDay}
                    /day
                  </p>
                ) : null}
              </div>
              {selectedProduct.available === "rent" ? (
                [
                  <div className="cb-body">
                    <p>Damage Waiver:</p>
                    <select
                      name="dmg-w"
                      id="dmg-w"
                      onChange={e =>
                        this.setState({
                          waiver: !!parseInt(e.target.value, 10)
                        })
                      }
                    >
                      <option value={0}>No Damage Waiver</option>
                      <option value={1}>Add Damage Waiver</option>
                    </select>
                  </div>,

                  <div className="cb-body">
                    <p>Quantity:</p>
                    <select
                      name="dmg-w"
                      id="dmg-w"
                      onChange={e =>
                        this.setState({
                          quantity: parseInt(
                            e.target.value === 1 ? 1 : e.target.value,
                            10
                          )
                        })
                      }
                    >
                      {new Array(selectedProduct.qty)
                        .fill(null)
                        .map((qty, key) => (
                          <option value={key + 1}>{key + 1}</option>
                        ))}
                    </select>
                  </div>
                ]
              ) : selectedProduct.available === "downloadable" ? (
                this.isBought() ? (
                  <div className="cb-body">
                    <p>
                      You've already purchased this downloadable item, you can
                      download it by pressing the "Download" button below!
                    </p>
                  </div>
                ) : (
                  <div className="cb-body">
                    <p>
                      Once you finish purchasing the item, you can download it
                      anytime by visiting the account page and switching over to
                      the "My Downloads" tab.
                    </p>
                  </div>
                )
              ) : (
                <div className="cb-body" />
              )}
              {selectedProduct.available === "rent" ? (
                <div className="cb-bottom">
                  {/* <div className="days-selector">
                    <input
                      name="rent"
                      id="rent"
                      className="single-rent"
                      type="number"
                      min={1}
                      defaultValue={this.state.selectedDays}
                      onChange={e =>
                        this.setState({
                          selectedDays: e.target.value > 0 ? e.target.value : 1
                        })
                      }
                    />
                    <p>Days</p>
                  </div> */}

                  {this.inCart() ? (
                    <Link to="/cart">
                      <button>ALREADY IN CART</button>
                    </Link>
                  ) : (
                    <button
                      onClick={() =>
                        this.props.CartStore.addToCart(
                          {
                            ...toJS(selectedProduct),
                            days: this.state.selectedDays,
                            selectedWaiver: this.state.waiver
                          },
                          this.state.quantity
                        )
                      }
                    >
                      ADD TO CART
                    </button>
                  )}
                </div>
              ) : (
                <div className="cb-bottom">
                  {this.isBought() ? (
                    <button
                      onClick={() =>
                        this.props.history.push("/account/downloads")
                      }
                    >
                      DOWNLOAD
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        selectedProduct.available === "rent"
                          ? this.props.CartStore.addToCart(
                              {
                                ...toJS(selectedProduct),
                                days: this.state.selectedDays,
                                selectedWaiver: this.state.waiver
                              },
                              this.state.quantity
                            )
                          : this.props.UserStore.user &&
                            this.props.UserStore.user.username
                          ? this.toggleDownloadProduct(selectedProduct)
                          : this.props.history.push("/register")
                      }
                    >
                      PURCHASE
                    </button>
                  )}
                </div>
              )}
            </div>
            <div className="freq">
              <div className="side-feat-list">
                <div className="section-title">
                  <p>Frequently Rented With:</p>
                  <div className="sep" />
                </div>
                <div className="list">
                  {selectedProduct.relatedProducts
                    ? selectedProduct.relatedProducts
                        .sort((product, itemToCompare) =>
                          product.score > itemToCompare.score
                            ? -1
                            : product.score === itemToCompare.score
                            ? 0
                            : 1
                        )
                        .map(product => (
                          <a
                            onClick={() =>
                              this.props.ProductStore.getProduct(product._id)
                            }
                          >
                            <div className="entry">
                              <img src={product.images[0]} alt="" />
                              <div className="feat-details">
                                <p>{product.name}</p>
                                <div className="pricing">
                                  <p>7 days</p>
                                  <p>
                                    ${(product.pricePerDay * 2.95).toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </a>
                        ))
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SingleProduct;



// WEBPACK FOOTER //
// ./src/components/SingleProduct.js